import React from 'react';
import {View} from 'react-native';
import {isNil, noop, pickBy} from 'lodash';

import {styles as cardStyles} from '/component/base/Card/Card.style';
import LoadingIndicator from '/component/base/LoadingIndicator';
import {Rank} from '/constant/TestIDs';
import {ID_BY_RANK} from '/enum/rank.enum';
import testProperties from '/util/testing/testProperties';

import ProgressTarget from '../ProgressTarget';
import targetConfig from '../targetConfig';

import {styles} from './Detail.style';

import {FEATURE_FLAGS} from '/DevFeatureFlags';
interface DetailProps {
  rankId: number;
  coachId: number | null;
  hasShadow: boolean;
  progressionData: Record<string, any> | null;
  hasProgressionData: boolean;
  getRankProgression: () => void;
}
export class Detail extends React.PureComponent<DetailProps> {
  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    const {hasProgressionData = false} = this.props;

    if (!hasProgressionData) {
      // Wait for any potential screen transition/animation is done before ...
      setTimeout(() => {
        // ... fetching rank progression data from the API.
        this.fetchRankProgressionData();
      }, 500);
    }
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidUpdate(prevProps: DetailProps): void {
    const hadProgressionData = prevProps.hasProgressionData;
    const {hasProgressionData = false} = this.props;

    if (hadProgressionData && !hasProgressionData) {
      this.fetchRankProgressionData();
    }
  }

  fetchRankProgressionData(): void {
    const {getRankProgression = noop} = this.props;
    getRankProgression();
  }

  renderTarget(
    name: string,
    position: {index: number; total: number},
  ): React.ReactNode {
    const {coachId = null, progressionData = {}} = this.props;

    const {
      dataComponent,
      dataComponentProps,
      extendedDataComponent,
      extendedDataComponentProps,
      isComplete,
      hasExtendedDetail,
      testID,
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    } = targetConfig[name] || {};

    if (!progressionData) return null;
    const data = progressionData[name];

    const getAccessibilityLabel = (title: any, current: any, target: any) => {
      const currentNum = Number(current);
      const targetNum = Number(target);

      let status = '';
      if (currentNum >= targetNum) {
        status = currentNum === targetNum ? 'Completed' : 'Goal exceeded';
      } else {
        const remaining = targetNum - currentNum;
        status = `${remaining} more needed`;
      }

      return `${title}. ${currentNum} out of ${targetNum}. ${status}.`;
    };

    const targetStyle = {
      ...styles.targetContainer,
      ...(position.index > 0 ? styles.targetWithBorder : {}),
      ...(position.index >= position.total - 1 ? styles.lastTarget : {}),
    };

    return (
      <View {...testProperties(testID)} key={name} style={targetStyle}>
        <ProgressTarget
          coachId={coachId}
          name={name}
          data={data}
          isComplete={isComplete(data)}
          dataComponent={dataComponent}
          dataComponentProps={dataComponentProps}
          extendedDataComponent={extendedDataComponent}
          extendedDataComponentProps={extendedDataComponentProps}
          hasExtendedDetail={hasExtendedDetail}
          accessibilityLabel={getAccessibilityLabel(
            name,
            data.current ?? data.currentCount,
            data.target,
          )}
        />
      </View>
    );
  }

  renderTargets() {
    const {progressionData = {}, rankId = 0} = this.props;

    // First pick fields applicable for this user
    const applicableTargetConfig = pickBy(targetConfig, ({presentedFor}: any) =>
      presentedFor?.some((rank: string) => ID_BY_RANK[rank] === rankId),
    );

    if (!progressionData) return null;
    // then grab a list of progression target names from the given data ...
    const targetNames = Object.keys(progressionData);

    // ... and only take the ones with have predefined configuration.
    // Also, remove the certification if FEATURE_FLAGS is false
    const configuredTargetNames = targetNames.filter(name => {
      if (
        !FEATURE_FLAGS.showCertificationReference &&
        name === 'certification'
      ) {
        return false;
      }
      return !isNil(applicableTargetConfig[name]);
    });

    // Sort the list of progression target names by their defined sort order.
    const sortedTargetNames = configuredTargetNames.sort((aName, bName) => {
      return (
        applicableTargetConfig[aName].sortOrder -
        applicableTargetConfig[bName].sortOrder
      );
    });

    return sortedTargetNames.map((name, index) =>
      this.renderTarget(name, {index, total: sortedTargetNames.length}),
    );
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {hasShadow = false, hasProgressionData = false} = this.props;

    const style = [styles.base];
    if (hasShadow) {
      // @ts-expect-error TS(2345): Argument of type '{ elevation: number; shadowColor... Remove this comment to see the full error message
      style.push(cardStyles.shadow);
    }

    return (
      <View {...testProperties(Rank.rankAdvancementBanner)} style={style}>
        {hasProgressionData ? (
          this.renderTargets()
        ) : (
          <LoadingIndicator style={styles.loading} />
        )}
      </View>
    );
  }
}

export default Detail;
